<template>
  <div class="reg_box">
    <div class="title">
      <p>登录</p>
    </div>
    <div class="form_box">
      <div style="display: flex;align-items: center;margin-bottom: 0.3rem;font-size: 0.3rem;">
        <label for="username" style="font-size: 0.3rem;width: 1.3rem;">账号：</label>
        <input id="username" v-model="formInline.username" type="text" placeholder="请输入账号"
          style="width: 100%;height: 0.6rem;font-size: 0.25rem;padding: 0 0.1rem;box-sizing: border-box;border: 1px solid #ccc;" />
      </div>
      <div style="display: flex;align-items: center;margin-bottom: 0.3rem;font-size: 0.3rem;">
        <label for="password" style="font-size: 0.3rem;width: 1.3rem;">密码：</label>
        <input id="password" v-model="formInline.password" type="password" placeholder="请输入密码"
          style="width: 100%;height: 0.6rem;font-size: 0.25rem;padding: 0 0.1rem;box-sizing: border-box;border: 1px solid #ccc;" />
      </div>

      <div style="width: 100%;">
        <button class="button" type="button" @click="login" style="background-color: var(--color-primary);">登录</button>
        <div style="display: flex;align-items: center;justify-content: space-between;margin-top: 0.5rem;">
          <button class="button" type="button" @click="register"
            style="background-color: var(--color-primary-light-3);width: 40%;">注册</button>
          <button class="button" type="button" @click="toConfig"
            style="background-color: var(--color-primary-light-3);width: 40%;">系统配置</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CallPubMsg } from '@/utils/request'
import { md5 } from 'js-md5';
import router from '../../../router';

export default {
  name: 'Login',
  data() {
    return {
      // Vue2中响应式数据放在data里，无需ref包裹
      formInline: {
        username: 'tsapi6',
        password: '123456',
        hsp_cd: '',
      },
      // 初始化store实例
      // usrstore: useAuthStore()
    }
  },
  mounted() {
    // Vue2使用this.$nextTick替代nextTick函数
    this.$nextTick(() => {
      // 保存Vue实例引用，解决回调中this指向问题
      const vm = this;
      window.getVueMessage = (data) => {
        console.log('收到来自App的消息：', JSON.stringify(data));
        if (data.type === 'cache_data') {
          setTimeout(() => {
            console.log('收到来自App的配置数据：', JSON.stringify(data));
            
            vm.getAPPConfig(data.data)
          }, 500); // 500ms延迟，可根据设备调整
          
        }
      };
    });
  },
  methods: {
    // 注册跳转方法
    register() {
      this.$store.state.auth.isLoginPages = false;
    },

    // 处理App配置数据
    getAPPConfig(datas) {
      console.log('收到来自App的配置数据：', JSON.stringify(datas));
      let data = JSON.parse(JSON.stringify(datas))
      console.log('收到来自App的配置数据2：', data.client_cd);
      console.log('收到来自App的配置数据3：', data.client_cd !== '');

      if (data.client_cd === '') {
        // Vue2直接使用this调用全局通知方法
        this.$myNotify({
          title: '警告',
          message: '客户端未注册，请先注册客户端！',
          type: 'warning'
        })
        return
      } else {
        // this.usrstore.SetClientConfig(data)
        // this.usrstore.SetClientGate(data.client_gate)
        // this.usrstore.SetTokenConfig(data)
        this.$store.commit('auth/SET_CLIENT_CONFIG', data);
        this.$store.commit('auth/SET_CLIENT_GATE', data.client_gate);
        this.$store.commit('auth/SET_TOKEN_CONFIG', data);
      }

      this.formInline.hsp_cd = data.client_hsp
      this.formInline.username = data.usr_gid
      this.formInline.password = data.usr_pwd

      if (data.client_cd && data.usr_gid && data.usr_pwd) {
        // 自动登录
        this.login()
      }
    },

    // 登录核心方法（保留async/await，Vue2支持）
    async login() {
      if (this.$store.state.auth.CLIENT_CONFIG.client_cd === '') {
        this.$myNotify({
          title: '警告',
          message: '客户端未注册，请先注册客户端！',
          type: 'warning'
        })
        return
      }
      if (this.formInline.username === '') {
        this.$myNotify({
          title: '警告',
          message: '请输入账号！',
          type: 'warning'
        })
        return
      }
      if (this.formInline.password === '') {
        this.$myNotify({
          title: '警告',
          message: '请输入密码！',
          type: 'warning'
        })
        return
      }

      let pdata = {
        system: 'his',
        client_cd: this.$store.state.auth.CLIENT_CONFIG.client_cd,
        client_dev: this.$store.state.auth.CLIENT_CONFIG.client_dev,
        usr_gid: this.formInline.username,
        hsp_cd: this.$store.state.auth.CLIENT_CONFIG.client_hsp,
        usr_pwd: md5(this.formInline.password),
        offline: 1,
        client_type: 8
      }
      console.log('执行登录操作', JSON.stringify(pdata));

      const res = await CallPubMsg('/auth/login', pdata);
      console.log('登录结果：', JSON.stringify(res));
      if (res.sta !== 1) {
        this.$myNotify({
          title: '警告',
          message: res.message || '登录失败！',
          type: 'error'
        })
        return
      }

      if (!res.body.res) {
        this.$myNotify({
          title: '警告',
          message: res.msg || '登录失败！',
          type: 'error'
        })
        return
      }

      // 登录成功
      this.$myNotify({
        title: '提示',
        message: '登录成功！',
        type: 'success'
      })

      // 存储用户信息和令牌
      let loginInfo = {
        usr_gid: this.formInline.username,
        token: res.body.accessToken,
        expires: new Date(),
        usr_cd: res.body.usr_cd,
        usr_nm: res.body.usr_nm,
        usr_role: [],
        usr_pwd: '',
        grp_cd: res.body.grp_cd,
        hsp_cd: res.body.hsp_cd,
        role_cd: 0,
        usr_tag: {},
        run_id: res.body.run_id
      };

      this.$store.commit('auth/SET_TOKEN_CONFIG', loginInfo);
      router.push('/home');
      // this.$store.state.auth.router = 'home';
    },

    // 跳转系统配置
    toConfig() {
      console.log('跳转系统配置');
      // postMessageToApp('instruct', 'app_toConfig', '');
      if (this.$isAppEnvironment()) {
        // 发送关闭APP指令
        this.$postMessageToApp('instruct', 'app_toConfig', '');
      } else {
        alert('当前非APP环境');
      }
    }
  }
}
</script>

<style scoped>
/* 基础容器样式 - 展开SCSS嵌套 */
.reg_box {
  width: 100%;
  height: 100%;
  border-radius: 0.1rem;
  color: #000;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.input_box {
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
  font-size: 0.3rem;
}

.button {
  font-size: 0.3rem;
  height: 0.7rem;
  /* line-height: 0.7rem; */
  /* margin: 0 0.1rem; */
  /* padding: 0 0.2rem; */
  color: #fff;
  border: none;
  border-radius: 0.1rem;
  cursor: pointer;
}

.button:active {
  opacity: 0.8;
}

/* 标题样式 */
.reg_box .title {
  font-size: 0.5rem;
  font-weight: 800;
  margin-top: -2rem;
  margin-bottom: 0.1rem;
  text-align: center;
}

/* 表单容器样式 */
.reg_box .form_box {
  width: 100%;
  padding: 0 0.2rem;
  box-sizing: border-box;
}

/* 按钮区域样式 */
.reg_box .form_box .button {
  width: 100%;
}

.reg_box .form_box .button div {
  margin-top: 0.2rem;
  display: flex;
  justify-content: space-between;
}

/* 设备信息样式（预留） */
.reg_box .form_box .dev_info {
  display: flex;
  justify-content: space-between;
  font-size: 0.25rem;
}

/* Vue2深度选择器：/deep/ 替代 :deep() */
.reg_box .form_box /deep/ .el-form-item {
  margin-bottom: 0.3rem !important;
}

.reg_box .form_box /deep/ .el-radio.el-radio--large .el-radio__label {
  font-size: 0.27rem !important;
}

.reg_box .form_box /deep/ .el-form-item__label {
  margin-right: 0.1rem !important;
}

.reg_box .form_box /deep/ .el-radio.el-radio--large .el-radio__inner {
  width: 0.25rem;
  height: 0.25rem;
}

.reg_box .form_box /deep/ .el-input__inner {
  height: 0.6rem !important;
  font-size: 0.25rem !important;
}

.reg_box .form_box /deep/ .el-form-item--large {
  --font-size: 0.25rem !important;
}

.reg_box .form_box /deep/ .el-form-item__label {
  height: 0.6rem !important;
  line-height: 0.6rem !important;
}
</style>